import { createFileRoute } from "@tanstack/react-router"
import { procedureTypeSettingsDetailViewStaticData } from "src/views/ProcedureTypeSettingsDetailView/constants"
import { ProcedureTypeSettingsDetailView } from "src/views/ProcedureTypeSettingsDetailView/ProcedureTypeSettingsDetailView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/",
)({
	component: ProcedureTypeSettingsDetailView,
	staticData: procedureTypeSettingsDetailViewStaticData,
})
